<div class="flex flex-col min-h-screen">
    <app-header></app-header>
    <div class="main-area flex-grow">
        <router-outlet />
    </div>
</div>
<app-footer></app-footer>